import { createSvgIcon } from '@mui/material/utils';
import Box from '@mui/material/Box';
import './LoadingIcon.css';

// Loading icon is created inside js in order to make it load together with the main js file
const LoadingIcon = createSvgIcon(
    <svg viewBox="0 0 100 100">
        <g>
            <circle r="3.5" cx="50" cy="10" transform="rotate(-30 50 50)" />

            <circle r="4" cx="50" cy="10" transform="rotate(0 50 50)" />
            <circle r="4.5" cx="50" cy="10" transform="rotate(30 50 50)" />
            <circle r="5" cx="50" cy="10" transform="rotate(60 50 50)" />

            <circle r="5.5" cx="50" cy="10" transform="rotate(90 50 50)" />
            <circle r="6" cx="50" cy="10" transform="rotate(120 50 50)" />
            <circle r="6.5" cx="50" cy="10" transform="rotate(150 50 50)" />

            <circle r="7" cx="50" cy="10" transform="rotate(180 50 50)" />
            <circle r="7.5" cx="50" cy="10" transform="rotate(210 50 50)" />
            <circle r="8" cx="50" cy="10" transform="rotate(240 50 50)" />
        </g>
    </svg>,
    'Loading'
);

const RotatingLoadingIcon = ({ sx }) => {
    return <Box className="loading-icon" sx={sx} >
        <LoadingIcon sx={{ fontSize: 'inherit' }} />
    </Box>
};

export default RotatingLoadingIcon;
